/**
 * @generated SignedSource<<2fde8fdab4c767324468d2db49234323>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type ResourceCriteriaResourceTypesPaginationQuery$variables = {
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  filter?: FilterElementInput | null | undefined;
};
export type ResourceCriteriaResourceTypesPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ResourceCriteria_resourceTypes">;
};
export type ResourceCriteriaResourceTypesPaginationQuery = {
  response: ResourceCriteriaResourceTypesPaginationQuery$data;
  variables: ResourceCriteriaResourceTypesPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 100,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "filterElement",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResourceCriteriaResourceTypesPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ResourceCriteria_resourceTypes"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResourceCriteriaResourceTypesPaginationQuery",
    "selections": [
      {
        "alias": "resourceCriteriaTypes",
        "args": (v1/*: any*/),
        "concreteType": "ResourceTypeConnection",
        "kind": "LinkedField",
        "name": "resourceTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ResourceTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResourceType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "qualifiedName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "resourceCriteriaTypes",
        "args": (v1/*: any*/),
        "filters": [
          "filterElement"
        ],
        "handle": "connection",
        "key": "ResourceCriteria__resourceCriteriaTypes",
        "kind": "LinkedHandle",
        "name": "resourceTypes"
      }
    ]
  },
  "params": {
    "cacheID": "2a6a2cd73c937098425cd0dcf8997522",
    "id": null,
    "metadata": {},
    "name": "ResourceCriteriaResourceTypesPaginationQuery",
    "operationKind": "query",
    "text": "query ResourceCriteriaResourceTypesPaginationQuery(\n  $count: Int = 100\n  $cursor: String\n  $filter: FilterElementInput\n) {\n  ...ResourceCriteria_resourceTypes_3KQYpM\n}\n\nfragment ResourceCriteria_resourceTypes_3KQYpM on Query {\n  resourceCriteriaTypes: resourceTypes(first: $count, after: $cursor, filterElement: $filter) {\n    edges {\n      node {\n        qualifiedName\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "530a21cf454a5d77c01b1716c3214694";

export default node;
